const baseURL = 'https://jm.komerzy.com/backend/';
export default baseURL;
